
const Logo = (props) => {
    return (  
        <img src="/images/logo.png" alt="Logo" className={props.size}/>
    );
}
 
export default Logo;